import { render, staticRenderFns } from "./TameLegend.vue?vue&type=template&id=11d7781f"
import script from "./TameLegend.vue?vue&type=script&lang=js"
export * from "./TameLegend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports